import { render, staticRenderFns } from "./ForumDetail.vue?vue&type=template&id=65369e07&scoped=true&"
import script from "./ForumDetail.vue?vue&type=script&lang=js&"
export * from "./ForumDetail.vue?vue&type=script&lang=js&"
import style0 from "./ForumDetail.vue?vue&type=style&index=0&id=65369e07&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65369e07",
  null
  
)

export default component.exports